import React, { Component } from 'react';
import './InventoryOverviewRow.css';
import Label from '../../../../components/label/Label';
import Divider from '../../../../components/divider/Divider';
import Chart from 'chart.js';
import models from '../../../../model/models';
import utils from '../../../../utils/utils';
import classNames from 'classnames';
import drugUtils from '../../../../utils/drugUtils';

let thirtyDays = 1000 * 60 * 60 * 24 * 30;

export default class InventoryOverviewRow extends Component {
	componentDidMount = async () => {
		this.subscribeId = models.drug_box.onChange(this._getData);
		await this._getData();
	};

	componentWillUnmount = () => {
		models.drug_box.unsubscribe(this.subscribeId);
	};

	componentWillReceiveProps = async () => {
		await this._getData();
	};

	_getData = () => {
		let drug_boxs = models.drug_box.objs();
		this.setState({ drug_boxs });
	};

	dayDiff = (first, second) => {
		return parseInt((second.getTime() - first.getTime()) / (1000 * 60 * 60 * 24));
	};

	_getData = () => {
		let usage = this.props.usage;
		if (!usage) return;
		let days = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
		let ready = true;
		let thirtyDaysAgo = utils.xDaysAgo(30);
		for (let i in usage) {
			let stock_move = usage[i];
			if (!stock_move.id) continue;
			if (!stock_move.created_on) continue;
			if (stock_move.type !== this.props.type) continue;
			ready = true;
			let day = utils
				.server_to_client_datetime(stock_move.created_on)
				.toISOString()
				.substring(0, 10);
			let dayIndex = this.dayDiff(thirtyDaysAgo, new Date(day));
			days[dayIndex] += 1;
		}
		this.setState({ days, ready }, this.drawGraph);
	};
	_labels = () => {
		let labels = [];
		for (let i = 1; i <= 30; i++) {
			let daysAgo = utils.xDaysAgo(30 - i);
			labels.push(utils.display_date(daysAgo));
		}
		return labels;
	};

	drawGraph = () => {
		if (!this.state.ready) return;
		var ctx = document.getElementById('GraphOverview' + this.props.type).getContext('2d');
		var grd = ctx.createLinearGradient(0, 0, 0, 50);
		grd.addColorStop(0, '#98dcff');
		grd.addColorStop(1, 'white');

		var chart = new Chart(ctx, {
			type: 'line',
			options: {
				maintainAspectRatio: false,
				legend: { display: false },
				// tooltips:{
				//   callbacks:{
				//     label:function(tooltipItem, data){
				//       return "verified by john doe" + data
				//     }
				//   }
				// },
				scales: { yAxes: [{ display: false }], xAxes: [{ display: false }] }
			},
			data: {
				labels: this._labels(),
				datasets: [
					{
						data: this.state.days,
						backgroundColor: grd,
						cubicInterpolationMode: true,
						pointRadius: 0,
						pointHitRadius: 10,
						borderColor: '#0ca5ff',
						borderWidth: 1,
						labels: this._labels()
					}
				]
			}
		});
	};

	_maxVialAnyTypeCount = () => {
		let count = {};
		for (let i in this.props.drugs) {
			let drug = this.props.drugs[i];
			if (drug.stock_move_record__quantity <= 0) continue;
			if (drug.expiration_date && drug.expiration_date.getTime() < Date.now()) continue;
			if (!count[drug.type]) count[drug.type] = 0;
			count[drug.type]++;
		}
		let max = 0;
		for (let i in count) {
			if (count[i] > max) {
				max = count[i];
			}
		}
		return max;
	};

	_totalVialCount = () => {
		return drugUtils.totalCount(this.props.drugs, this.props.type);
	};
	_centralVialCount = () => {
		return drugUtils.centralCount(this.props.drugs, this.props.type);
	};

	_deployedVialCount = () => {
		return drugUtils.deployedCount(this.props.drugs, this.props.type);
	};

	_drugCount = (total = false, centralSupplyOnly = false) => {
		let count = 0;
		for (let i in this.props.drugs) {
			let drug = this.props.drugs[i];
			let box = models.drug_box.obj(drug.drug_box_id);
			if (!box) box = {};
			if (centralSupplyOnly && !box.central_supply) continue;
			if (!total && !centralSupplyOnly && box.central_supply) continue;
			// if (drug.expiration_date.getTime() < Date.now()) continue;
			if (this.props.type === drug.type && drug.stock_move_record__quantity > 0) count++;
		}
		return count;
	};
	_parDifference = (type) => {
		let par = this.props[type];
		let value = this.props.daysRemaining;
		if (type === 'parVials') {
			value = this._totalVialCount();
		}
		let above = value >= par;
		if (above) {
			let dif = value - par;
			let percent = parseInt((dif / par) * 100);
			return (
				<Label gray-medium small className="percent-row">
					<Label green small bold>
						{percent || 0}%
					</Label>
					ABOVE PAR
				</Label>
			);
		} else {
			let dif = Math.abs(value - par);
			let percent = parseInt((dif / par) * 100);
			return (
				<Label gray-medium small className="percent-row">
					<Label red medium-small bold>
						{percent || 0}%
					</Label>
					BELOW PAR
				</Label>
			);
		}
	};

	_deployedWidth = () => {
		let deployed = this._deployedVialCount();
		let central = this._centralVialCount();
		let total = deployed + central;
		let percentDeployed = deployed / total;
		return percentDeployed * this._totalWidth() + 71 + 'px';
	};
	_centralWidth = () => {
		let deployed = this._deployedVialCount();
		let central = this._centralVialCount();
		let total = deployed + central;
		let percentDeployed = central / total;
		return percentDeployed * this._totalWidth() + 71 + 'px';
	};

	_totalWidth = () => {
		let element = document.getElementsByClassName('volume')[0];
		let total = 0;
		if (!element) {
			total = 444 - 142;
		} else {
			total = element.getBoundingClientRect().width - 142;
		}
		return total * (this._totalVialCount() / this._maxVialAnyTypeCount());
	};

	render() {
		const drugType = models.drug_type.obj(this.props.type) || {};
		const typeName = drugType.name || this.props.type;
		return (
			<div className={classNames('g-inventory-overview-row', this.props.className)}>
				<div className="left">
					<Label black> {typeName.toUpperCase()}</Label>
					<div className="volume">
						<Label white medium-small style={{ width: this._deployedWidth() }}>
							<strong>{this._deployedVialCount()}</strong> vials
						</Label>
						<Label white medium-small style={{ width: this._centralWidth() }}>
							<strong>{this._centralVialCount()}</strong> vials
						</Label>
					</div>
				</div>
				<div className="right">
					<div className="column">
						<Label gray-medium medium-small>
							Total vials
						</Label>
						<Label larger black>
							{this._drugCount(true)}
						</Label>
						{this._parDifference('parVials')}
					</div>
					<Divider vertical />
					<div className="column">
						<Label gray-medium medium-small>
							Usage last 30 days
						</Label>
						<div className="graph">
							<canvas height="60px" width="140px" id={'GraphOverview' + this.props.type}>
								graph
							</canvas>
						</div>
					</div>
					{/*<Divider vertical />*/}
					{/*<div className="column supply-left">*/}
					{/*	<Label gray-medium medium-small>*/}
					{/*		<Label gray-medium medium-small>*/}
					{/*			Days of supply left*/}
					{/*		</Label>*/}
					{/*		<Label gray-dark className="hover">*/}
					{/*			{' '}*/}
					{/*			We look at how much of this drug you have used in the last 30 days to project how much you will need*/}
					{/*		</Label>*/}
					{/*	</Label>*/}
					{/*	<Label larger black>*/}
					{/*		{utils.display_number(this.props.daysRemaining || 0)}*/}
					{/*	</Label>*/}
					{/*</div>*/}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/dashboardPage/inventoryOverviewCard/inventoryOverviewRow/InventoryOverviewRow.jsx